import React from 'react'
import useCanvas from 'hooks/useCanvas'

const Canvas = props => {
	let {
		draw,
		option = {},
		width = 500,
		height = 500,
		...rest
	} = props;

	const canvasRef = useCanvas(draw, option);

	return (
		<canvas
			width={width}
			height={height}
			ref={canvasRef}
			{...rest}
		/>
	);
}

export default Canvas
